<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2">Membros da Cooperativa</h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-group mr-2">
          <BaseButtonComponent
            :to="`/cooperative-members/new/${state.cooperative}`"
            variant="primary-action"
            >Novo</BaseButtonComponent
          >
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3"
    >
      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
      ></b-form-input>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Nome</td>
            <td>CPF/CNPJ</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ formatSocialNumber(item.socialNumber) }}</td>
            <td>
              <BaseButtonComponent
                :to="
                  `/cooperative-members/edit/${state.cooperative}/${item.id}`
                "
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'cooperative-members-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        cooperative: 0,
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    this.state.cooperative = this.$route.params.id;

    await this.getAll();
  },
  methods: {
    formatSocialNumber(socialNumber) {
      if (socialNumber.length === 11) {
        return socialNumber.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4',
        );
      } else {
        return socialNumber.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          '$1.$2.$3/$4-$5',
        );
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path:
            `/cooperatives-members-list/${this.state.cooperative}` +
            helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model, cooperative: this.state.cooperative };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/cooperative-members/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Cooperativa excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
